<template>
    <v-dialog
            v-model="isDialogOpen"
            width="600"
            hide-overlay
            transition="dialog-bottom-transition"
    >
        <v-toolbar
                flat
                dark
                class="main--yellow"
        >
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click.native="$emit('close')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card>

            <v-container class="app-container">
                <v-card-title class="justify-center text-center title">
                    <span>{{ $t('writeSellerFeedback') }}</span><span class="pl-2">{{ $t('aboutProduct') }}</span><span class="pl-2"> {{ productName }}</span></v-card-title>
                <v-divider class="my-2"></v-divider>
                <v-row>
                    <v-col cols="12" class="pt-2 pt-md-6">
                        <v-card-text>{{ $t('feedbackOne') }} {{ $t('aboutProduct') }}:</v-card-text>
                        <v-textarea
                                outlined
                                v-model="messageText"
                                :placeholder="$t('commentAboutCompany')"
                                color="orange lighten-2"
                                filled
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div class="d-flex align-center">
                    <v-btn class="my-4 px-6 main--yellow" dark @click="send">
                        {{ $t('addFeedback') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text class="text--main-yellow" @click.native="$emit('close')">{{$t('cancel')}}</v-btn>
                </div>
            </v-container>
        </v-card>

        <v-snackbar
                color="main--black"
                dark
                v-model="snackOpen"
                top
        >
            {{$t('thankYouForFeedback')}}
            <div class="d-flex">
                <!--<v-btn text class="text&#45;&#45;main-yellow" link @click="seeFeedback" >{{ $t('look') }}</v-btn>-->
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </v-dialog>
</template>

<script>

    import ActionAccess from '../../../app-front/mixins/ActionAccess';
    import AppSnack from '../../../general/mixins/AppSnack';
    import DialogRemote from '../../mixins/DialogRemote';
    import ProductService from '../../../app-front/services/api/ProductService';
    import SnackGeneral from '../snacks/SnackGeneral';

    export default {
        name: "ProductFeedbackDialog",
        props:['product', 'productName'],
        mixins:[DialogRemote, AppSnack, ActionAccess],
        components:{SnackGeneral},
        data(){
            return {
                messageText: null,
                snackData: {
                    isOpen: false,
                    color: null,
                    text: null
                },
                rating: null,
                result: {
                    css: '',
                    header: '',
                    id: null
                },
            }
        },
        methods: {
            seeFeedback() {
                this.$emit('see-feedback');
            },
            send() {
                const params = {
                    productId: this.product,
                    content: this.messageText,
                };

                ProductService.createProductFeedback(params)
                    .then(() => {
                        this.result.css = 'success';
                        this.result.header = this.$t('feedbackSend');
                        this.openSnack();

                        this.$emit('feedback-change');

                        setTimeout(() => {
                            this.$emit('close');
                        }, 3000);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
        }
    }
</script>

<style scoped>

</style>
